import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseError } from '@/types/Error';
import { PdfResponse } from '@/types/Pdf';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const pdfApi = createApi({
  reducerPath: 'pdfApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: 'pawtree/pdfs', useStrapiServer: true }),
  tagTypes: ['Pdf'],
  endpoints: builder => ({
    getPdfById: builder.query<PdfResponse, number>({
      query: id => ({
        url: `/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: PdfResponse) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: (result, error, id) => [{ type: 'Pdf', id }],
    }),
    getAllPdfs: builder.query<PdfResponse[], void>({
      query: () => ({
        url: '',
        method: 'GET',
      }),
      transformResponse: (response: PdfResponse[]) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['Pdf'],
    }),
  }),
});

export const { useGetPdfByIdQuery, useGetAllPdfsQuery } = pdfApi;
